export default __webpack_public_path__ + "static/media/BeOneUp.6990d604.png";